import type { ThemeTokens } from './theme.tokens';

/**
 * Valores por defecto del tema (tenant `default`).
 * Alineados con `src/colors.scss` (violet 500, turquoise 500, orangeTiger 500).
 * Alineados con `src/colors.scss` y `src/theme-variables.scss` (bootstrap CSS).
 */
export const DEFAULT_THEME_TOKENS: ThemeTokens = {
    primary: '#441d99',
    primaryDarker: '#1b0c3d',
    primaryLighter: '#c7bbe0',
    primaryLightest: '#f3eef9',
    secondary: '#5ccccc',
    secondaryLighter: '#cef0f0',
    secondaryDarker: '#30adad',
    accent: '#5ccccc',
    error: '#eb880e',
    errorLighter: '#f9dbb7',
    errorDarker: '#dd5804',
    textPrimary: '#1b0c3d',
    textSecondary: '#3b3b3b',
    background: '#ffffff',
    backgroundSecondary: '#f9f8fc',
    borderRadius: '4px',
    fontFamily: "'Montserrat', sans-serif",
};
